// src/WallpaperDoneList.js
import React, { useEffect, useState } from 'react';
import { getFirestore, collection, query, where, onSnapshot } from "firebase/firestore";
import app from './firebase';
import WallpaperItemAdvanced from './WallpaperItemAdvanced';

export default function WallpaperDoneList() {
  const [wallpapers, setWallpapers] = useState([]);
  const [allAlbums, setAllAlbums] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const [selectedAlbum, setSelectedAlbum] = useState('ALL');
  const [categoryFilter, setCategoryFilter] = useState('');
  const [tagFilter, setTagFilter] = useState('');
  const [sortLikes, setSortLikes] = useState('');
  const [sortDownloads, setSortDownloads] = useState('');

  const [visibleCount, setVisibleCount] = useState(30);

  // 🔥 Učitavanje svih "done" wallpapera
  useEffect(() => {
    const db = getFirestore(app);
    const q = query(
      collection(db, "wallpapers"),
      where("status", "==", "done")
    );
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const items = [];
      snapshot.forEach(doc => {
        const data = doc.data();
        items.push({
          id: doc.id,
          ...data,
          likes: data.likes ?? 0,
          downloads: data.downloads ?? 0
        });
      });
      setWallpapers(items);
      setLoaded(true);
    });
    return () => unsubscribe();
  }, []);

  // 🔥 Dinamičko učitavanje svih albuma iz homepage_albums
  useEffect(() => {
    const db = getFirestore(app);
    const unsubscribe = onSnapshot(collection(db, "homepage_albums"), (snapshot) => {
      const albumList = snapshot.docs
        .map((doc) => doc.data().title)
        .filter(Boolean)
        .sort();
      setAllAlbums(albumList);
    });
    return () => unsubscribe();
  }, []);

  // 🔁 Infinite scroll
  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 200 &&
        visibleCount < filteredWallpapers.length
      ) {
        setVisibleCount((prev) => prev + 30);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [visibleCount, wallpapers, selectedAlbum, categoryFilter, tagFilter, sortLikes, sortDownloads]);

  const addAlbumGlobal = (newAlbum) => {
    const trimmed = newAlbum.trim();
    if (trimmed && !allAlbums.includes(trimmed)) {
      setAllAlbums(prev => [...prev, trimmed].sort());
    }
  };

  const filteredWallpapers = wallpapers
    .filter((wp) => {
      const matchAlbum = selectedAlbum === 'ALL' || (wp.albums && wp.albums.includes(selectedAlbum));
      const matchCategory = categoryFilter === '' || (wp.categories && wp.categories.some((cat) => cat.toLowerCase().includes(categoryFilter.toLowerCase())));
      const matchTags = tagFilter === '' || (wp.tags && wp.tags.some((tag) => tag.toLowerCase().includes(tagFilter.toLowerCase())));
      return matchAlbum && matchCategory && matchTags;
    })
    .sort((a, b) => {
      if (sortLikes === 'desc') return (b.likes || 0) - (a.likes || 0);
      if (sortLikes === 'asc') return (a.likes || 0) - (b.likes || 0);
      if (sortDownloads === 'desc') return (b.downloads || 0) - (a.downloads || 0);
      if (sortDownloads === 'asc') return (a.downloads || 0) - (b.downloads || 0);
      return 0;
    });

  return (
    <div style={{ margin: 30 }}>
      <h2>Done Wallpapers</h2>

      <div style={{ marginBottom: 20, display: 'flex', gap: 20, flexWrap: 'wrap' }}>
        <div>
          <label>Album:</label>
          <select value={selectedAlbum} onChange={(e) => setSelectedAlbum(e.target.value)} style={{ marginLeft: 10 }}>
            <option value="ALL">Svi</option>
            {allAlbums.map((album) => (
              <option key={album} value={album}>{album}</option>
            ))}
          </select>
        </div>

        <div>
          <label>Kategorija:</label>
          <input
            type="text"
            value={categoryFilter}
            onChange={(e) => setCategoryFilter(e.target.value)}
            placeholder="npr. pink"
            style={{ marginLeft: 10 }}
          />
        </div>

        <div>
          <label>Tag:</label>
          <input
            type="text"
            value={tagFilter}
            onChange={(e) => setTagFilter(e.target.value)}
            placeholder="npr. heart"
            style={{ marginLeft: 10 }}
          />
        </div>

        <div>
          <label>Sortiraj po lajkovima:</label>
          <select value={sortLikes} onChange={(e) => setSortLikes(e.target.value)} style={{ marginLeft: 10 }}>
            <option value="">---</option>
            <option value="desc">Najviše → najmanje</option>
            <option value="asc">Najmanje → najviše</option>
          </select>
        </div>

        <div>
          <label>Sortiraj po preuzimanjima:</label>
          <select value={sortDownloads} onChange={(e) => setSortDownloads(e.target.value)} style={{ marginLeft: 10 }}>
            <option value="">---</option>
            <option value="desc">Najviše → najmanje</option>
            <option value="asc">Najmanje → najviše</option>
          </select>
        </div>
      </div>

      {!loaded ? (
        <p>Loading...</p>
      ) : filteredWallpapers.length === 0 ? (
        <p>Nema pronađenih wallpapera.</p>
      ) : (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
          {filteredWallpapers.slice(0, visibleCount).map((wp) => (
            <div key={wp.id} style={{ flex: '0 0 calc(50% - 20px)' }}>
              <WallpaperItemAdvanced
                wallpaper={wp}
                allAlbums={allAlbums}
                addAlbumGlobal={addAlbumGlobal}
              />
              <div style={{ marginTop: 5, color: '#ccc', fontSize: 14 }}>
                ❤️ Likes: {wp.likes} | ⬇ Downloads: {wp.downloads}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
